import { IPractice } from "../../components/RightPanel/Execution/ExecutionDetail/Types";
import { HttpRequest } from "../../utilities/HttpRequest";

export interface PracticeRequestPayload {
  postcode: string;
  radius: string;
  dsa: string;
}

export interface PracticeResponse {
  data: {
    practices: IPractice[];
  };
}

export interface IPracticeService {
  getPractices(payload: PracticeRequestPayload, signal: AbortSignal): Promise<IPractice[]>;
}

export class PracticeService implements IPracticeService {
  public async getPractices(payload: PracticeRequestPayload, signal: AbortSignal): Promise<IPractice[]> {
    const request = {
      relativeUrl: "/v1/practices?search=practices",
      endPoint: process.env.APP_FEASIBILITY_SERVICE_API,
      request: payload,
      signal
    };

    const response = await HttpRequest.post(request);

    const practiceResponse = response as unknown as PracticeResponse;
    return practiceResponse.data.practices;
  }
}
